import "@/App.css";
import Navigation from "@/components/landing/Navigation";
import HeroSection from "@/components/landing/HeroSection";

import FeaturesSection from "@/components/landing/FeaturesSection";
import ScreenshotGallery from "@/components/landing/ScreenshotGallery";
import InteractiveDemo from "@/components/landing/InteractiveDemo";
import WhoIsItFor from "@/components/landing/WhoIsItFor";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";

function App() {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif" }}>
      <Navigation />
      <HeroSection />
      <FeaturesSection />
      <ScreenshotGallery />
      <InteractiveDemo />
      <WhoIsItFor />
      <FinalCTA />
      <Footer />
    </div>
  );
}

export default App;
